
export class KpUniversalFormConfigurationService {
    public static serviceName = 'universalFormConfigurationService';

    #autofocusFirstField = false;

    public get autofocusFirstField(): boolean {
        return this.#autofocusFirstField;
    }

    public set autofocusFirstField(value) {
        this.#autofocusFirstField = value;
    }


}